import { CommonModule } from '@angular/common'
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { RouterModule } from '@angular/router'

import { CyborgUIModule } from '@cyborg-monorepo/common/angular/cyborg-ui'
import {
  BadgeComponent,
  ButtonComponent,
  ButtonMenuComponent,
  CodeBlockComponent,
  DropdownMenuComponent,
  DropdownMenuItemComponent,
  ErrorComponent,
  IconComponent,
  InputComponent,
  LinkComponent,
  MultiSelectComponent,
  NoticeComponent,
  SelectComponent,
  TabBarComponent,
  TabComponent,
  TagComponent,
  TextAreaComponent,
  TypographyComponent,
  MarkdownComponent,
  ReusableDialogComponent,
} from '@hyperkit'

import { SearchStateService } from '../research/services/search-state.service'
import { SearchUrlService } from '../research/services/search-url.service'

import { AllActiveFiltersComponent } from './components/all-active-filters/all-active-filters.component'
import { ContactCyborgComponent } from './components/contact-cyborg/contact-cyborg.component'
import { DateRangeFilterComponent } from './components/custom-filters/date-range-filter.component'
import { DropDownFilterComponent } from './components/custom-filters/dropdown-filter.component'
import { MultiselectEnvironmentFilterComponent } from './components/custom-filters/multiselect-environment-filter.component'
import { MultiselectTagFilterComponent } from './components/custom-filters/multiselect-tag-filter.component'
import { CyborgContentComponent } from './components/cyborg-content/cyborg-content.component'
import { CyborgEnvironmentContentComponent } from './components/cyborg-environment-content/cyborg-environment-content.component'
import { HuntModuleDialogComponent } from './components/dialogs/hunt-module-dialog/hunt-module-dialog.component'
import { NewTemplateDialogComponent } from './components/dialogs/new-template-dialog/new-template-dialog.component'
import { PremiumDialogComponent } from './components/dialogs/premium-dialog/premium-dialog.component'
import { TalkToCyborgDialogComponent } from './components/dialogs/talk-to-cyborg-dialog/talk-to-cyborg-dialog.component'
import { UnlockModalComponent } from './components/dialogs/unlock/unlock.component'
import { FacetButtonsComponent } from './components/facet-buttons/facet-buttons.component'
import { HuntPackageComponent } from './components/hunt-package/hunt-package.component'
import { HuntPackageTrialResolver } from './components/hunt-package/hunt-package.resolver'
import { HuntPackageOverviewComponent } from './components/hunt-package-overview/hunt-package-overview.component'
import { MitreTechniqueMultiselectComponent } from './components/mitre-multiselect/mitre-multiselect.component'
import { QueryLogicComponent } from './components/query-logic/query-logic.component'
import { SearchSortComponent } from './components/search-sort/search-sort.component'
import { ThreatProfileComponent } from './components/threat-profiles/threat-profiles.component'
import { TrialLockUnlockComponent } from './components/trial-lock-unlock/trial-lock-unlock.component'
import { IframeAwareRouterLinkDirective } from './directives/iframe-aware-router-link.directive'
import { CompanyStatusPipe } from './pipes/company-status.pipe'
import { OutcomeBadgePipe } from './pipes/outcome-badge.pipe'
import { PriorityBadgePipe } from './pipes/priority-badge.pipe'
import { SeverityBadgePipe } from './pipes/severity-badge.pipe'
import { SnakeToTitlePipe } from './pipes/snake-to-title.pipe'
import { StatusBadgePipe } from './pipes/status-badge.pipe'
import { FavoriteService } from './services/favorite.service'
import { FrameDetectionService } from './services/frame-detection.service'

@NgModule({
  declarations: [
    DropDownFilterComponent,
    DateRangeFilterComponent,
    MultiselectTagFilterComponent,
    MultiselectEnvironmentFilterComponent,
    HuntPackageComponent,
    ThreatProfileComponent,
    AllActiveFiltersComponent,
    TrialLockUnlockComponent,
    UnlockModalComponent,
    QueryLogicComponent,
    NewTemplateDialogComponent,
    TalkToCyborgDialogComponent,
    HuntModuleDialogComponent,
    PremiumDialogComponent,
    ContactCyborgComponent,
    SearchSortComponent,
    CyborgEnvironmentContentComponent,
    CyborgContentComponent,
    MitreTechniqueMultiselectComponent,
    PriorityBadgePipe,
    OutcomeBadgePipe,
    StatusBadgePipe,
    SeverityBadgePipe,
    SnakeToTitlePipe,
    CompanyStatusPipe,
    IframeAwareRouterLinkDirective,
  ],
  providers: [
    HuntPackageTrialResolver,
    FavoriteService,
    SearchStateService,
    FrameDetectionService,
    SearchUrlService,
  ],
  imports: [
    CommonModule,
    CyborgUIModule,
    RouterModule,
    TagComponent,
    BadgeComponent,
    IconComponent,
    CodeBlockComponent,
    InputComponent,
    MultiSelectComponent,
    NoticeComponent,
    TextAreaComponent,
    SelectComponent,
    TypographyComponent,
    TabBarComponent,
    TabComponent,
    ButtonComponent,
    LinkComponent,
    ButtonMenuComponent,
    DropdownMenuComponent,
    DropdownMenuItemComponent,
    MarkdownComponent,
    ReusableDialogComponent,
    ErrorComponent,
    FacetButtonsComponent,
    HuntPackageOverviewComponent,
  ],
  exports: [
    ReusableDialogComponent,
    PriorityBadgePipe,
    OutcomeBadgePipe,
    StatusBadgePipe,
    CompanyStatusPipe,
    SnakeToTitlePipe,
    SeverityBadgePipe,
    IframeAwareRouterLinkDirective,
    DropDownFilterComponent,
    DateRangeFilterComponent,
    MultiselectTagFilterComponent,
    MultiselectEnvironmentFilterComponent,
    HuntPackageComponent,
    ThreatProfileComponent,
    AllActiveFiltersComponent,
    FacetButtonsComponent,
    TrialLockUnlockComponent,
    UnlockModalComponent,
    QueryLogicComponent,
    HuntPackageOverviewComponent,
    NewTemplateDialogComponent,
    TalkToCyborgDialogComponent,
    HuntModuleDialogComponent,
    PremiumDialogComponent,
    ContactCyborgComponent,
    SearchSortComponent,
    CyborgEnvironmentContentComponent,
    CyborgContentComponent,
    MitreTechniqueMultiselectComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}
